//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getIndustry,getBidStatus,getServiceContent} from '@/assets/js/dict';
export default {
    created(){
        getIndustry().then(res=>{
            this.industryList=res
        })
        getServiceContent().then(res=>{
            this.serviceContList = res
        })
        getBidStatus().then(res=>{
            this.bidList = res
        })
    },
    data: () => ({
        industryList:[],
        serviceContList:[],
        bidList:[],
        list:[],
        loading:false,
        finished:false,
        form:{
            title: '',
            industry:'',
            serviceContent:'',
            serviceType:'',
            bidStatus:'',
            total: 10,
            pageIndex: 1,
            pageSize: 10,
        }
    }),
    methods: {
       // 投标列表
        getList(page){
            if(page){
                this.list=[]
                this.form.pageIndex=page
            }
            this.loading=true;
            this.$get('/tra/project/tbList',this.form,function(res){
               if(res.code==200){
                    var newArr = res.data.records;
                    if (!newArr || newArr.length === 0) {
                        this.finished = true
                    } else {
                        for(var i=0;i<newArr.length;i++){
                            if(newArr[i].serviceContent&&newArr[i].serviceContent!=''){
                                newArr[i].serviceContents= eval(newArr[i].serviceContent).toString();
                            }else{
                                newArr[i].serviceContents='';
                            }
                        }
                        this.list.push(...newArr)
                        this.form.pageIndex = this.form.pageIndex + 1
                    }
                    this.loading = false
               }
            })
        },
        // 点击搜索
        search(){
            this.getList(1)
        },

        // 投标详情
        detail(id){
            this.$router.push({
                path:'/facilitator/bidProInfo?id='+id
            })
        }
    },
    mounted() {
       
    }
}
